export default {
  PLACEHOLDER: 'placeholder',
  TEXT_BELOW: 'textBelow',
  TOOLTIP: 'tooltip',
};
